import Me1 from "./ME1.png";
import Me2 from "./ME2.png";
import Me3 from "./ME3.png";
import anime from "./anime.jpg";
import bard from "./bard.png";
import blackWoman from "./black-woman.jpg";
import closeUpBlack from "./close-up-black.jpg";
import codeman from "./mancode.jpg";
import cody from "./cody.jpg";
import figma from "./figma.jpg";
import illus from "./illus.jpg";
import ilustrator from "./photoshop.jpg";
import photoreg from "./phoreg.jpg";
import progbg from "./progbackground.jpg";
import proglang from "./proglags.jpg";
import reactImg from "./react.jpg";

export const Sliders = [
    {id: 1,
    name: "black Woman",
    src: blackWoman},
    {id: 2,
    name: "anime",
    src: anime},
    { id: 3,
    name: "Close up black woman",
    src: closeUpBlack},
    {id: 4,
    name: "cody",
    src: cody},
    {id: 5,
    name: "adobe ",
    src: illus},
    {id: 6,
    name: "code man",
    src: codeman},
   {id: 7,
    name: "photoshop",
    src: photoreg},
    {id: 8,
    name: "illstrator",
    src: ilustrator},
    {id: 9,
    name: "programing background",
    src: progbg},
    {id: 10,
    name: "progaming languages",
    src: proglang},
    {id: 11,
    name: "react",
    src: reactImg},
    {id: 12,
    name: "figma",
    src: figma}
]

export const bardImg = bard

export const Mee = [
    {
        id: 1,
        name: "My first",
        src: Me1
    },
    {
        id: 2,
        name: "My second",
        src: Me2
    },
    {
        id: 3,
        name: "My third",
        src: Me3
    },
]